<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card-group deck>
          <b-card align="center" class="reports-last-card" v-if="accessExtras.INFORME_VISITAS.status">
            <div class="app-modal-header reports-last-card__header">
              <span class="app-modal-header__icon"><AppIcon name="geo-alt" /></span>
              <h5 class="app-modal-header__title">Última Visita</h5>
            </div>
            <div class="reports-last-card__body">
              <template v-if="lastReports.visits">
                <div class="reports-last-card__time">{{lastReports.visits.timeAgo}}</div>
                <div class="reports-last-card__meta">
                  {{moment(lastReports.visits.date).format('DD/MM/YYYY')}}
                  <span v-if="lastReports.visits.responsable"> · {{lastReports.visits.responsable}}</span>
                </div>
              </template>
              <b-badge v-else variant="secondary">Sin registros</b-badge>
            </div>
          </b-card>

          <b-card align="center" class="reports-last-card" v-if="accessExtras.INFORME_COBRANZAS.status">
            <div class="app-modal-header reports-last-card__header">
              <span class="app-modal-header__icon"><AppIcon name="money" /></span>
              <h5 class="app-modal-header__title">Última Cobranza</h5>
            </div>
            <div class="reports-last-card__body">
              <template v-if="lastReports.payments">
                <div class="reports-last-card__time">{{lastReports.payments.timeAgo}}</div>
                <div class="reports-last-card__meta">
                  {{moment(lastReports.payments.date).format('DD/MM/YYYY')}}
                  <span v-if="lastReports.payments.responsable"> · {{lastReports.payments.responsable}}</span>
                </div>
              </template>
              <b-badge v-else variant="secondary">Sin registros</b-badge>
            </div>
          </b-card>

          <b-card align="center" class="reports-last-card" v-if="accessExtras.INFORME_NOVEDADES.status">
            <div class="app-modal-header reports-last-card__header">
              <span class="app-modal-header__icon"><AppIcon name="megaphone" /></span>
              <h5 class="app-modal-header__title">Última Novedad</h5>
            </div>
            <div class="reports-last-card__body">
              <template v-if="lastReports.news">
                <div class="reports-last-card__time">{{lastReports.news.timeAgo}}</div>
                <div class="reports-last-card__meta">
                  {{moment(lastReports.news.date).format('DD/MM/YYYY')}}
                  <span v-if="lastReports.news.responsable"> · {{lastReports.news.responsable}}</span>
                </div>
              </template>
              <b-badge v-else variant="secondary">Sin registros</b-badge>
            </div>
          </b-card>
        </b-card-group>
      </b-col>

      <b-col lg="12" class="mt-3">
        <b-card-group deck>
          <b-card align="center" class="reports-last-card" v-if="accessExtras.INFORME_SERVICIOS.status">
            <div class="app-modal-header reports-last-card__header">
              <span class="app-modal-header__icon"><AppIcon name="tools" /></span>
              <h5 class="app-modal-header__title">Último Servicio</h5>
            </div>
            <div class="reports-last-card__body">
              <template v-if="lastReports.services">
                <div class="reports-last-card__time">{{lastReports.services.timeAgo}}</div>
                <div class="reports-last-card__meta">
                  {{moment(lastReports.services.date).format('DD/MM/YYYY')}}
                  <span v-if="lastReports.services.responsable"> · {{lastReports.services.responsable}}</span>
                </div>
              </template>
              <b-badge v-else variant="secondary">Sin registros</b-badge>
            </div>
          </b-card>

          <b-card align="center" class="reports-last-card" v-if="accessExtras.INFORME_MARKETING.status">
            <div class="app-modal-header reports-last-card__header">
              <span class="app-modal-header__icon"><AppIcon name="graph-up" /></span>
              <h5 class="app-modal-header__title">Último Marketing</h5>
            </div>
            <div class="reports-last-card__body">
              <template v-if="lastReports.marketing">
                <div class="reports-last-card__time">{{lastReports.marketing.timeAgo}}</div>
                <div class="reports-last-card__meta">
                  {{moment(lastReports.marketing.date).format('DD/MM/YYYY')}}
                  <span v-if="lastReports.marketing.responsable"> · {{lastReports.marketing.responsable}}</span>
                </div>
              </template>
              <b-badge v-else variant="secondary">Sin registros</b-badge>
            </div>
          </b-card>

          <b-card align="center" class="reports-last-card" v-if="accessExtras.INFORME_AUDITORIA.status">
            <div class="app-modal-header reports-last-card__header">
              <span class="app-modal-header__icon"><AppIcon name="shield-check" /></span>
              <h5 class="app-modal-header__title">Última Auditoría</h5>
            </div>
            <div class="reports-last-card__body">
              <template v-if="lastReports.audit">
                <div class="reports-last-card__time">{{lastReports.audit.timeAgo}}</div>
                <div class="reports-last-card__meta">
                  {{moment(lastReports.audit.date).format('DD/MM/YYYY')}}
                  <span v-if="lastReports.audit.responsable"> · {{lastReports.audit.responsable}}</span>
                </div>
              </template>
              <b-badge v-else variant="secondary">Sin registros</b-badge>
            </div>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>

    <b-card class="mt-3">
      <div class="app-modal-header crud-customer-reports-header">
        <span class="app-modal-header__icon"><AppIcon name="history" /></span>
        <h5 class="app-modal-header__title">Historial de Informes</h5>
        <div class="crud-customer-reports-header__actions">
          <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }"
                    v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                    :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                    @click="filtersOpen = !filtersOpen">
            <AppIcon name="filter" :fill="filtersOpen" />
          </b-button>
          <b-dropdown right no-caret variant="link" boundary="window"
                      toggle-class="list-view-icon-btn list-view-icon-btn--primary"
                      v-b-tooltip.hover.bottom title="Cargar Informe"
                      v-if="canCreateAnyReport">
            <template #button-content>
              <AppIcon name="add" label="Cargar Informe" />
            </template>
            <b-dropdown-item v-if="accessExtras.INFORME_VISITAS.status" @click="goReportVisit()"><AppIcon name="geo-alt" /> Visitas</b-dropdown-item>
            <b-dropdown-item v-if="accessExtras.INFORME_COBRANZAS.status" @click="goReportPayment()"><AppIcon name="money" /> Cobranzas</b-dropdown-item>
            <b-dropdown-item v-if="accessExtras.INFORME_NOVEDADES.status" @click="goReportNews()"><AppIcon name="megaphone" /> Novedades</b-dropdown-item>
            <b-dropdown-item v-if="accessExtras.INFORME_SERVICIOS.status && !isSeller" @click="goReportServices()"><AppIcon name="tools" /> Servicios</b-dropdown-item>
            <b-dropdown-item v-if="accessExtras.INFORME_MARKETING.status && !isSeller" @click="goReportMarketing()"><AppIcon name="graph-up" /> Marketing</b-dropdown-item>
            <b-dropdown-item v-if="accessExtras.INFORME_AUDITORIA.status && !isSeller" @click="goReportAudit()"><AppIcon name="shield-check" /> Auditoría</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <b-collapse v-model="filtersOpen">
        <div class="list-view-toolbar__filters reports-history-filters">
          <div class="list-view-filter" style="flex: 1 1 200px; max-width: 280px;">
            <label class="filter-label">Tipo</label>
            <v-select :options="arr.filters.types" v-model="filters.types" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
          </div>
          <div class="list-view-filter" style="width: 150px;">
            <label class="filter-label">Desde</label>
            <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
          </div>
          <div class="list-view-filter" style="width: 150px;">
            <label class="filter-label">Hasta</label>
            <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
          </div>
          <div class="list-view-filter" style="flex: 1 1 170px; max-width: 210px;">
            <label class="filter-label">Estado</label>
            <v-select :options="arr.filters.readStatus" v-model="filters.readStatus" :clearable="false" :multiple="false" :select-on-tab="true"></v-select>
          </div>
          <b-button variant="outline-dark" size="sm" @click="filterReports()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
            <AppIcon name="filter" />
          </b-button>
        </div>
      </b-collapse>

      <b-table class="mb-0 app-table crud-customer-reports-table"
              responsive
              :stacked="isMobileViewport ? 'md' : false"
              sticky-header="60vh"
              :hover="true"
              :small="true"
              :fixed="false"
              :items="table.items"
              :fields="table.fields"
              @row-clicked="onRowClicked"
              :busy="table.isBusy"
              v-if="table.items.length || table.isBusy">

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Cargando...</strong>
            </div>
          </template>

          <template v-slot:cell(date)="data">
            {{moment(data.item.date).format('DD/MM/YYYY')}}
          </template>

          <template v-slot:cell(type)="data">
            <b-badge :variant="reportTypeVariant(data.item.type)" pill>
              <AppIcon :name="reportTypeIcon(data.item.type)" class="mr-1" />{{reportTypeLabel(data.item.type)}}
            </b-badge>
          </template>

          <template v-slot:cell(observations)="data">
            <div v-if="data.item.type == 'COBRANZAS'" class="text-muted small">Recibo #{{data.item.id}}</div>
            <div v-if="data.item.observations" class="text-truncate crud-customer-reports-observations" v-b-tooltip.hover :title="data.item.observations">
              {{data.item.observations}}
            </div>
            <span v-else-if="data.item.type != 'COBRANZAS'" class="text-muted">—</span>
          </template>

          <template v-slot:cell(responsable)="data">
            <span v-if="data.item.responsable"><AppIcon name="person" class="mr-1 text-muted" />{{data.item.responsable}}</span>
            <span v-else class="text-muted">—</span>
          </template>

          <template v-slot:cell(amount)="data">
            <span v-if="data.item.type == 'COBRANZAS' && data.item.amount">
              {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(data.item.amount)}}
            </span>
          </template>

          <template v-slot:cell(read)="data">
            <b-badge :variant="data.item.read ? 'secondary' : 'dark'" pill>{{data.item.read ? 'Leído' : 'Sin abrir'}}</b-badge>
          </template>

          <template v-slot:cell(f_action)="data">
            <b-dropdown right
                        no-caret
                        size="sm"
                        variant="link"
                        boundary="window"
                        :toggle-class="isMobileViewport ? 'crud-customer-reports-action-toggle-labeled' : 'app-table-action-toggle'"
                        :class="{ 'pull-right': !isMobileViewport }">
              <template #button-content>
                <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                <span v-if="isMobileViewport">Opciones</span>
              </template>
              <b-dropdown-item @click="goDetailReport(data.item, data.item.type)">
                <AppIcon name="visibility" /> Ver detalle
              </b-dropdown-item>
            </b-dropdown>
          </template>
      </b-table>
      <EmptyState v-else icon="reports" title="No se encontraron informes" description="Ajustá los filtros para ampliar la búsqueda." />

      <div class="app-table-footer">
        <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
        <b-pagination v-if="table.tablePaginate && table.tablePaginate.last_page > 1"
                      class="mb-0 ml-3"
                      size="sm"
                      pills
                      :total-rows="table.tablePaginate.total"
                      :per-page="table.tablePaginate.per_page"
                      v-model="table.currentPage"
                      @input="loadReports()" />
      </div>
    </b-card>
  </div>
</template>
<script>
    import serviceAPI from './../services'
    import Error from '@/handler/error'
    import Modules from '@/config/modules'
    import Helper from '@/handler/helper'
    import moment from 'moment'

    export default {
        props: [
            'customers',
            'customersID',
            'reports'
        ],
        data() {
            return {
                filtersOpen: false,
                isMobileViewport: false,
                table: {
                    items: [],
                    fields: [],
                    currentPage: 1,
                    isBusy: false,
                    tablePaginate: null,
                },
                filters: {
                    types: [],
                    date_start: '',
                    date_end: '',
                    readStatus: {code: 'all', label: 'Todos'},
                },
                arr: {
                    filters: {
                        types: [],
                        readStatus: [
                            {code: 'all', label: 'Todos'},
                            {code: true, label: 'Leídos'},
                            {code: false, label: 'Sin abrir'},
                        ],
                    },
                },
                accessExtras:{
                  INFORME_VISITAS: {
                    module: Modules.INFORME_VISITAS,
                    status: false
                  },
                  INFORME_COBRANZAS: {
                    module: Modules.INFORME_COBRANZAS,
                    status: false
                  },
                  INFORME_NOVEDADES: {
                    module: Modules.INFORME_NOVEDADES,
                    status: false
                  },
                  INFORME_SERVICIOS: {
                    module: Modules.INFORME_SERVICIOS,
                    status: false
                  },
                  INFORME_MARKETING: {
                    module: Modules.INFORME_MARKETING,
                    status: false
                  },
                  INFORME_AUDITORIA: {
                    module: Modules.INFORME_AUDITORIA,
                    status: false
                  }
                },
            }
        },
        computed: {
            isSeller(){
                if(Helper.getSeller()) {
                    return true
                } else {
                    return false
                }
            },
            canCreateAnyReport() {
                return this.accessExtras.INFORME_VISITAS.status ||
                       this.accessExtras.INFORME_COBRANZAS.status ||
                       this.accessExtras.INFORME_NOVEDADES.status ||
                       (this.accessExtras.INFORME_SERVICIOS.status && !this.isSeller) ||
                       (this.accessExtras.INFORME_MARKETING.status && !this.isSeller) ||
                       (this.accessExtras.INFORME_AUDITORIA.status && !this.isSeller)
            },
            // Reemplaza setInfoToReports() (armaba HTML a mano con v-html) por
            // datos planos que el template renderiza directo -- mismo criterio
            // en toda la app: nunca v-html para contenido que se puede templatear.
            lastReports() {
                var self = this
                var keys = ['visits', 'payments', 'news', 'services', 'marketing', 'audit']
                var result = {}

                keys.forEach(function(key) {
                    var item = self.customers && self.customers['last-reports-' + key]
                    if(!item) {
                        result[key] = null
                        return
                    }
                    result[key] = {
                        date: item.date,
                        // diff() sin unidad devuelve milisegundos -- hay que
                        // pedirle 'days' ahí mismo, no solo en duration(), o
                        // humanize() interpreta esos milisegundos como si ya
                        // fueran la cantidad de días (ej. "18653208 años").
                        timeAgo: moment.duration(moment().diff(moment(item.date), 'days'), 'days').humanize(),
                        responsable: item.staff ? item.staff.name : (item.seller ? item.seller.name : ''),
                    }
                })

                return result
            },
        },
        created() {
          /* Configurar permisos extras para vincular modulos */
          this.accessExtras.INFORME_VISITAS.status = Helper.moduleEnabled(this.accessExtras.INFORME_VISITAS.module)
          this.accessExtras.INFORME_COBRANZAS.status = Helper.moduleEnabled(this.accessExtras.INFORME_COBRANZAS.module)
          this.accessExtras.INFORME_NOVEDADES.status = Helper.moduleEnabled(this.accessExtras.INFORME_NOVEDADES.module)
          this.accessExtras.INFORME_SERVICIOS.status = Helper.moduleEnabled(this.accessExtras.INFORME_SERVICIOS.module)
          this.accessExtras.INFORME_MARKETING.status = Helper.moduleEnabled(this.accessExtras.INFORME_MARKETING.module)
          this.accessExtras.INFORME_AUDITORIA.status = Helper.moduleEnabled(this.accessExtras.INFORME_AUDITORIA.module)
          /* Fin configuracion */
        },
        mounted() {
            this.buildTypeFilterOptions()
            this.loadFieldTable()
            this.loadReports()

            this.mobileMql = window.matchMedia('(max-width: 767.98px)')
            this.isMobileViewport = this.mobileMql.matches
            this.mobileMql.addEventListener('change', this.updateMobileViewport)
        },
        beforeDestroy() {
            if(this.mobileMql) {
                this.mobileMql.removeEventListener('change', this.updateMobileViewport)
            }
        },
        watch: {
            isMobileViewport() {
                this.loadFieldTable()
            },
        },
        methods: {
            // RESPONSIVE
            updateMobileViewport(e) {
                this.isMobileViewport = e.matches
            },
            alignClass(desktopClass) {
                return this.isMobileViewport ? 'text-left' : desktopClass
            },
            // Auditoría queda afuera para un vendedor logueado, sea cual sea su
            // permiso de módulo -- mismo criterio que ya aplica el backend
            // (ver CustomersController::getReportsByCustomer).
            buildTypeFilterOptions() {
                this.arr.filters.types = []
                if(this.accessExtras.INFORME_VISITAS.status) this.arr.filters.types.push({code: 'VISITAS', label: 'Visitas'})
                if(this.accessExtras.INFORME_COBRANZAS.status) this.arr.filters.types.push({code: 'COBRANZAS', label: 'Cobranzas'})
                if(this.accessExtras.INFORME_NOVEDADES.status) this.arr.filters.types.push({code: 'NOVEDADES', label: 'Novedades'})
                if(this.accessExtras.INFORME_SERVICIOS.status) this.arr.filters.types.push({code: 'SERVICIOS', label: 'Servicios'})
                if(this.accessExtras.INFORME_MARKETING.status) this.arr.filters.types.push({code: 'MARKETING', label: 'Marketing'})
                if(this.accessExtras.INFORME_AUDITORIA.status && !this.isSeller) this.arr.filters.types.push({code: 'AUDITORIA', label: 'Auditoría'})
            },
            loadFieldTable() {
                this.table.fields = []
                this.table.fields.push({key: 'date', label: 'Fecha', class: 'align-middle ' + this.alignClass('text-left'), width: '110px'})
                this.table.fields.push({key: 'type', label: 'Tipo', class: 'align-middle ' + this.alignClass('text-left'), width: '130px'})
                this.table.fields.push({key: 'observations', label: 'Detalle', class: 'align-middle text-wrap ' + this.alignClass('text-left')})
                this.table.fields.push({key: 'responsable', label: 'Responsable', class: 'align-middle ' + this.alignClass('text-left'), width: '160px'})
                this.table.fields.push({key: 'amount', label: 'Monto', class: 'align-middle ' + this.alignClass('text-right'), width: '110px'})
                this.table.fields.push({key: 'read', label: 'Estado', class: 'align-middle ' + this.alignClass('text-center'), width: '110px'})
                this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle ' + this.alignClass('text-right'), width: '50px'})
            },
            // Íconos y colores por tipo -- mismos que ya usan las cards de
            // "Último informe" arriba, para que el badge de Tipo en la tabla
            // se lea como parte del mismo lenguaje visual.
            reportTypeIcon(type) {
                var icons = {VISITAS: 'geo-alt', COBRANZAS: 'money', NOVEDADES: 'megaphone', SERVICIOS: 'tools', MARKETING: 'graph-up', AUDITORIA: 'shield-check'}
                return icons[type] || 'description'
            },
            reportTypeVariant(type) {
                var variants = {VISITAS: 'info', COBRANZAS: 'success', NOVEDADES: 'warning', SERVICIOS: 'primary', MARKETING: 'secondary', AUDITORIA: 'dark'}
                return variants[type] || 'secondary'
            },
            reportTypeLabel(type) {
                var labels = {VISITAS: 'Visita', COBRANZAS: 'Cobranza', NOVEDADES: 'Novedad', SERVICIOS: 'Servicio', MARKETING: 'Marketing', AUDITORIA: 'Auditoría'}
                return labels[type] || type
            },
            onRowClicked(item, index, event) {
                if(!item) return

                if(event && event.target) {
                    const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
                    if(ignoreTags.includes(event.target.tagName)) return
                }

                this.goDetailReport(item, item.type)
            },
            filterReports() {
                this.loadReports(true)
            },
            loadReports(resetPage) {
                if(resetPage) this.table.currentPage = 1
                this.table.isBusy = true

                var data = {
                    customers_id: this.customersID,
                    types: this.filters.types.map(function(value) { return value.code }),
                    date_start: this.filters.date_start,
                    date_end: this.filters.date_end,
                }
                if(this.filters.readStatus && this.filters.readStatus.code !== 'all') {
                    data.readStatus = this.filters.readStatus.code
                }

                var result = serviceAPI.obtenerReportsByCustomers(data, this.table.currentPage)

                result.then((response) => {
                    var data = response.data
                    this.table.tablePaginate = data
                    this.table.items = data.data
                    this.table.isBusy = false
                })
                .catch(error => {
                    this.table.isBusy = false
                    this.$awn.alert(Error.showError(error))
                });
            },
            goDetailReport(item, type) {
                if(type=='VISITAS') {
                    this.$router.push({ name: 'ReportsVisitsStaffDetailReport', params: {reportID: item.id} })
                }

                if(type=='COBRANZAS') {
                    this.$router.push({ name: 'ReportsPaymentStaffDetailReport', params: {reportID: item.id} })
                }

                if(type=='NOVEDADES') {
                    this.$router.push({ name: 'ReportsNewsStaffDetailReport', params: {reportID: item.id} })
                }

                if(type=='SERVICIOS') {
                    this.$router.push({ name: 'ReportsServicesStaffDetailReport', params: {reportID: item.id} })
                }

                if(type=='AUDITORIA') {
                    this.$router.push({ name: 'ReportsAuditStaffDetailReport', params: {reportID: item.id} })
                }

                if(type=='MARKETING') {
                    this.$router.push({ name: 'ReportsMarketingStaffDetailReport', params: {reportID: item.id} })
                }
            },
            goReportVisit() {
                if(this.isSeller) {
                    this.$router.push({ name: 'ReportsVisitsStaffCrudReportSellerByCustomers', params: {customersID: this.customersID} })
                } else {
                    this.$router.push({ name: 'ReportsVisitsStaffCrudReportByCustomers', params: {customersID: this.customersID} })
                }
            },
            goReportPayment() {
                if(this.customers) {
                    if(this.isSeller) {
                        this.$router.push({ name: 'ReportsPaymentStaffCrudReportSellerByCustomers', params: {customersID: this.customers.id + '|' + this.customers.code} })
                    } else {
                        this.$router.push({ name: 'ReportsPaymentStaffCrudReportByCustomers', params: {customersID: this.customers.id + '|' + this.customers.code} })
                    }
                }
            },
            goReportNews() {
                if(this.isSeller) {
                    this.$router.push({ name: 'ReportsNewsStaffCrudReportSellerByCustomers', params: {customersID: this.customersID} })
                } else {
                    this.$router.push({ name: 'ReportsNewsStaffCrudReportByCustomers', params: {customersID: this.customersID} })
                }
            },
            goReportServices() {
                if(!this.isSeller) {
                    this.$router.push({ name: 'ReportsServicesStaffCrudReportByCustomers', params: {customersID: this.customersID} })
                }
            },
            goReportAudit() {
                if(!this.isSeller) {
                    this.$router.push({ name: 'ReportsAuditStaffCrudReportByCustomers', params: {customersID: this.customersID} })
                }
            },
            goReportMarketing() {
                if(!this.isSeller) {
                    this.$router.push({ name: 'ReportsMarketingStaffCrudReportByCustomers', params: {customersID: this.customersID} })
                }
            },
        }
    }
</script>
<style>
  .reports-last-card .card-body {
    padding: 14px 16px;
  }
  .reports-last-card__header {
    padding-bottom: 8px;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--app-color-border);
  }
  .reports-last-card__header .app-modal-header__title {
    font-size: 14px;
  }
  .reports-last-card__time {
    font-size: 1.3rem;
    font-weight: var(--app-font-bold);
    color: var(--app-color-text);
  }
  .reports-last-card__meta {
    margin-top: 2px;
    font-size: var(--app-text-xs);
    color: var(--app-color-text-muted);
  }
  .crud-customer-reports-header {
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid var(--app-color-border);
  }
  .crud-customer-reports-header__actions {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
  }
  .reports-history-filters {
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 16px;
    border-top: none;
    border-bottom: 1px solid var(--app-color-border);
  }
  .crud-customer-reports-observations {
    max-width: 280px;
  }
  /* Excepción al kebab mudo de .app-table: esta tabla no tiene drawer que
     aloje las acciones, así que se conserva también en mobile — como link
     de texto alineado a la izquierda, no como botón con caja. */
  .btn.crud-customer-reports-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-customer-reports-action-toggle-labeled:hover,
  .btn.crud-customer-reports-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  /* Pisa la regla global que oculta el label del último field y lo alinea
     a la derecha (pensada para el kebab ícono-only sin texto). */
  @media (max-width: 767.98px) {
    .crud-customer-reports-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
    .crud-customer-reports-table.app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
